<template>
  <div class="blog-article">
    <dynamic-image-background class="title-image" :fileId="blogArticle.titleImage"></dynamic-image-background>
    <div class="col-12 pb-4">
      <div class="d-flex mt-3">
        <div class="pr-2">
          <div style="width: 2.5rem;aspect-ratio: 1/1;background: var(--gray);border-radius: 50%;display: grid;place-items: center;">
            <i class="fa fa-user-edit" style="color:  var(--light);"></i>
          </div>
        </div>
        <div>
          <div>
            <small>
              <strong>
                {{blogArticle.author}}
              </strong>
            </small>
          </div>
          <div>
            <small>
              {{ _getFormattedDate(blogArticle.publishedOn, 'Do MMM YYYY')}}
            </small>
          </div>
        </div>
      </div>

      <h5 class="mt-4">{{ blogArticle.title}}</h5>

    </div>
    <div v-html="blogArticle.content" class="col-12"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      blogArticle: (state) => state.blogArticle,
    }),
  },
};
</script>

<style scoped>
.title-image {
  position: relative;
  height: 12rem;
  background-size: cover;
  background-repeat: no-repeat;
}
.title {
  position: absolute;
  bottom: 0;
}
</style>


